import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

export interface IdleDialogData {
    gracePeriodSeconds: number;
}

export type IdleDialogResult = undefined | 'logout' | 'login';

@Component({
    selector: 'se-idle-dialog',
    standalone: true,
    template: `
        <h2 mat-dialog-title translate>IdleTimeoutWarningTitle</h2>
        <mat-dialog-content class="mat-typography">
            <p *ngIf="remainingTime > 0" translate [translateParams]="{ p0: remainingTime }">
                IdleTimeoutWarningExpiring
            </p>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button mat-button mat-dialog-close>{{ 'Yes' | translate }}</button>
            <button mat-button mat-dialog-close="logout">{{ 'No' | translate }}</button>
        </mat-dialog-actions>
    `,
    imports: [CommonModule, TranslateModule, MatButtonModule, MatDialogModule]
})
export class IdleCheckerDialogComponent implements OnDestroy, OnInit {
    remainingTime = this.data.gracePeriodSeconds;
    gracePeriodIntervalId?: number;

    constructor(
        @Inject(MAT_DIALOG_DATA) private readonly data: IdleDialogData,
        readonly dialogRef: MatDialogRef<IdleDialogResult>,
    ) {}

    ngOnInit() {
        this.gracePeriodIntervalId = window.setInterval(() => {
            this.remainingTime -= 1;
            if (this.remainingTime <= 0) {
                this.dialogRef.close('login');
            }
        }, 1000);
    }

    ngOnDestroy() {
        clearInterval(this.gracePeriodIntervalId);
    }
}
